import type { PersistedDefaultTabProps, RowGroupsOpenedState } from '@talos/kyoko';
import type { CreditTableFilter, CreditTabProps } from './types';

export const defaultCreditRowGroupsOpened: RowGroupsOpenedState = {};
export const defaultCreditFilter: CreditTableFilter = {};

export const COUNTERPARTY_NOP_TAB_ID = 'counterparty-noc';
export const CREDIT_TABS_EXCLUDED_IDS = [COUNTERPARTY_NOP_TAB_ID];

const counterPartyNopTab: PersistedDefaultTabProps<CreditTabProps> = {
  label: 'Counterparty NOP',
  id: COUNTERPARTY_NOP_TAB_ID,
  closable: false,
  editable: false,
  defaultFilter: defaultCreditFilter,
  showZeroBalances: true,
};

export const DEFAULT_CREDIT_TABS: PersistedDefaultTabProps<CreditTabProps>[] = [counterPartyNopTab];
